import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API, BannerCarousel, FeaturedCarousel } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { formatBanners, formatFeaturedCarousel } from './banners.format'

export function use(
  client: WbsClient,
  banners: API['banners'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // GET /v3/carousels/banners
  banners.getBannersFx.use(async () => {
    const carousels = await payload(client.get.api.v3.carousels.banners())
    return carousels.map(formatBanners) as BannerCarousel[]
  })

  // GET /v3/carousels/featured
  banners.getFeaturedCarouselFx.use(async () => {
    const carousels = await payload(client.get.api.v3.carousels.featured())
    return carousels.map(formatFeaturedCarousel) as FeaturedCarousel[]
  })
}
